var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.0263C6.838 11.0263 5.9 10.0883 5.9 8.92627C5.9 8.14227 6.327 7.45627 6.95 7.09927L13.747 3.16527L9.876 9.87127C9.526 10.5573 8.819 11.0263 8 11.0263ZM8 1.92627C9.267 1.92627 10.45 2.27627 11.479 2.85027L10.009 3.69727C9.4 3.45927 8.7 3.32627 8 3.32627C4.906 3.32627 2.4 5.83227 2.4 8.92627C2.4 10.4733 3.023 11.8733 4.038 12.8813H4.045C4.1099 12.946 4.16138 13.0229 4.19651 13.1076C4.23163 13.1923 4.24971 13.2831 4.24971 13.3748C4.24971 13.4664 4.23163 13.5572 4.19651 13.6419C4.16138 13.7266 4.1099 13.8035 4.045 13.8683C3.772 14.1413 3.324 14.1413 3.051 13.8753C2.40002 13.2261 1.88371 12.4547 1.53173 11.6054C1.17976 10.7561 0.999054 9.84562 1 8.92627C1 5.07627 4.15 1.92627 8 1.92627ZM15 8.92627C15 10.8583 14.216 12.6083 12.949 13.8753C12.676 14.1413 12.235 14.1413 11.962 13.8683C11.8971 13.8035 11.8456 13.7266 11.8105 13.6419C11.7754 13.5572 11.7573 13.4664 11.7573 13.3748C11.7573 13.2831 11.7754 13.1923 11.8105 13.1076C11.8456 13.0229 11.8971 12.946 11.962 12.8813C12.4826 12.3628 12.8954 11.7464 13.1765 11.0676C13.4576 10.3888 13.6016 9.66099 13.6 8.92627C13.6 8.22627 13.467 7.52627 13.222 6.89627L14.069 5.42627C14.65 6.47627 15 7.65227 15 8.92627Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskProfile);
export default __webpack_public_path__ + "static/media/riskProfile.a07eabb78c9b1c241b1a69ad652fa16d.svg";
export { ForwardRef as ReactComponent };